<template>
  <div
      id="app"
      class="bg-white text-uppercase"
  >
    <router-view></router-view>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-inline: 0.2rem;
}
</style>
<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
};
</script>
<script setup></script>
